import { http, providerApi } from '@/core/api/';

export const compensatoryRequestSearchInitFilters = async () => {
  return await http.get(`api/compensatoryrequest/initfilters`);
};
export const compensatoryRequestSearch = async (
  filters,
  pageSize,
  currentPage
) => {
  return await providerApi.post(`api/compensatoryrequest/search?`, filters, {
    params: {
      pageSize: pageSize,
      currentPage: currentPage,
    },
  });
};

export const getCompensatoryRequestInterventions = (id) =>
  providerApi.get(`api/compensatoryrequest/interventions/${id}`);

export const getProvidersByAcademicyearId = async (academicYearId) => {
  return await providerApi.get(
    `api/providers/list/withsignedcontracts/${academicYearId}`
  );
};
export const getProvidersForDirectPayment = async (academicYearId) => {
  return await providerApi.get(
    `api/providers/list/fordirectpayment/${academicYearId}`
  );
};

export const submitClosingAnalysis = (id) => {
  return providerApi.put(`api/compensatoryrequest/submitClosingAnalysis/${id}`);
};

export const getCompensatoryRequestAnalysisData = (id) =>
  providerApi.get(`api/compensatoryrequest/replacement/${id}`);

export const getCompensatoryRequestReplacementStrategies = (replacementId) =>
  providerApi.get(
    `api/compensatoryrequest/replacementstrategies/${replacementId}`
  );

export const getCompensatoryDocumentTypes = (compensatoryRequestId) =>
  providerApi.get(
    `api/compensatoryrequest/documentTypes/${compensatoryRequestId}`
  );

export const replacementDocumentUpload = (params) =>
  providerApi.post(
    'api/compensatoryrequest/replacement/documentUpload',
    params,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

export const saveReferralItemAttachment = (params) =>
  providerApi.post(
    'api/compensatoryrequest/savereferralitemattachment',
    params,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  );

export const deleteCompensatoryDocument = (params) =>
  providerApi.post('api/compensatoryrequest/documentDelete', params);

export const completeReplacement = (payload) =>
  providerApi.put('api/compensatoryrequest/replacement', payload);

export const getStudentServices = (compensatoryRequestType, search) =>
  providerApi.get(
    `api/compensatoryrequest/studentservices/${compensatoryRequestType}/${search}`
  );

export const getVisits = (admissionId, requestType) =>
  providerApi.get(
    `api/compensatoryrequest/getvisits/${admissionId}/${requestType}`
  );

export const getCompesatoryRepositionAbsence = () =>
  providerApi.get('api/compensatoryrequest/compensatoryrepositionabsence');

export const getCompensatoryRequestStudentService = (params) =>
  providerApi.get('api/compensatoryrequest/request', { params: params });

export const getEducationalCompensatoryRequest = (id) =>
  providerApi.get(`api/compensatoryrequest/educationalrequest/${id}`);

export const saveCompensatoryRequest = (params) =>
  providerApi.post('api/compensatoryrequest/saveCompensatoryRequest', params);

export const getReferralDocumentsByStudentService = (
  payload,
  currentPage,
  pageSize
) =>
  providerApi.get(`api/compensatoryrequest/referral/documents`, {
    params: {
      ...payload,
      currentPage: currentPage,
      pageSize: pageSize,
    },
  });

//Determination Endpoints
export const getDeterminationReasons = () =>
  providerApi.get(`api/compensatoryrequest/reasons`);
export const isInterventionAreApproved = (requestId) =>
  providerApi.get(
    `api/compensatoryrequest/interventionAreApproved/${requestId}`
  );
export const submitDetermination = ({
  requestId,
  statusId,
  reasonId,
  comment,
}) =>
  providerApi.put(
    `api/compensatoryrequest/${requestId}/Determination/${statusId}`,
    { reasonId, comment }
  );

export const submitEducationalDetermination = ({
  requestId,
  statusId,
  reasonId,
  comment,
}) =>
  providerApi.put(
    `api/compensatoryrequest/educational/${requestId}/determination/${statusId}`,
    { reasonId, comment }
  );

export const submitIntervention = (item) => {
  return providerApi.post(
    `api/compensatoryrequest/replacement/interventionsDue`,
    item
  );
};

export const getCompensatoryRequestReplacementCommentsStrategies = (
  replacementId
) =>
  providerApi.get(
    `api/compensatoryrequest/replacementcommentstrategies/${replacementId}`
  );

export const resetReplacement = (compensatoryRequestId) =>
  providerApi.put(
    `api/compensatoryrequest/resetReplacement/${compensatoryRequestId}`
  );

export const rejectReasons = () =>
  providerApi.get('api/compensatoryrequest/rejectreasons');

export const getInterventions = (
  studentSieId,
  disciplineTypeId,
  peiId,
  params = {}
) =>
  http.get(
    `api/compensatoryrequest/interventionsDue/${studentSieId}/${disciplineTypeId}/${peiId}`,
    {
      params,
    }
  );
//
export const updateInterventions = (interventionsToCompensate) =>
  http.put(
    `api/compensatoryrequest/updateinterventionselection`,
    interventionsToCompensate,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

export const getInterventionSelection = (programServiceId) =>
  http.get(`api/compensatoryrequest/interventionselection/${programServiceId}`);

export const saveAttachmentWhenRejectCompensatory = (params) =>
  http.put('api/compensatoryrequest/rejectcompensatoryservice', params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const updateAmountWhenModifyCompensatory = (params) =>
  http.put('api/compensatoryrequest/modifycompensatoryservice', params, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

export const cleanCompensatoryService = (params) =>
  http.put('api/compensatoryrequest/cleancompensatoryservice', params, {
    headers: {
      'Content-Type': 'application/json',
    },
  });

export const getGeneralInfo = (compensatoryRequestId, isEducational = false) =>
  providerApi.get(
    `api/compensatoryrequest/generalinfo/${compensatoryRequestId}`,
    {
      params: {
        isEducational,
      },
    }
  );

export const hasInterventionsDue = (studentSieId) =>
  http.get(`api/compensatoryrequest/hasinterventionsdue/${studentSieId}`);

export const updateRequestStatusToPrevious = ({ id, comment }) =>
  providerApi.put(
    `api/compensatoryrequest/changerequeststatustoprevious/${id}`,
    { comment }
  );
